import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const table = [
  {
    prop: 'engine',
    label: i18n.t('irrigation.engine'),
    minWidth: 150,
  },
  {
    prop: 'ubicacion',
    label: i18n.t('common_words.location'),
    minWidth: 150,
  },
  {
    prop: 'hourmeter',
    label: i18n.t('irrigation.hourmeter'),
    minWidth: 150,
  },
  {
    prop: 'hydrometer',
    label: i18n.t('irrigation.hydrometer'),
    minWidth: 150,
  },
];

const pagination = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const functions = {
  pagedData() {
    return this.tableData.slice(this.from, this.to);
  },
  queriedData() {
    let result = this.tableData;
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;
    return result.slice(this.from, this.to);
  },
  to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
      highBound = this.total;
    }
    return highBound;
  },
  from() {
    return this.pagination.perPage * (this.pagination.currentPage - 1);
  },
  total() {
    // this.pagination.total = this.tableData.length;
    return this.pagination.total;
  },
};

export default { pagination, functions, table };
